import { Input } from "@ember/component";
import { on } from "@ember/modifier";
import { bind } from "discourse/lib/decorators";
import SearchFieldBase from "./base";
import SearchFieldWireFrame from "./wire-frame";

export default class SearchFieldConfirm extends SearchFieldBase {
  @bind
  onValueChanged(event) {
    const value = event.target.checked;
    this.args.controller.set(
      this.args.filter.queryParameter,
      value ? value : null
    );
  }

  <template>
    <SearchFieldWireFrame
      ...attributes
      @controller={{@controller}}
      @filter={{@filter}}
      @value={{@value}}
    >
      <label class="checkbox-label">
        <Input
          name={{@filter.name}}
          @checked={{readonly @value}}
          @type="checkbox"
          {{on "input" this.onValueChanged}}
        />
        <span>
          <span>
            {{this.placeholder}}
          </span>
        </span>
      </label>
    </SearchFieldWireFrame>
  </template>
}
